// removed by extract-text-webpack-plugin
module.exports = {"content":"PatientProfile__content__i-SYz","registryFormWrapper":"PatientProfile__registryFormWrapper__2yjW8","parentContainer":"PatientProfile__parentContainer__1fypu","searchWrapper":"PatientProfile__searchWrapper__3tEle","searchWrapperLabel":"PatientProfile__searchWrapperLabel__1qxEH","toggleHeadline":"PatientProfile__toggleHeadline__Dey8S","collapseIcon":"PatientProfile__collapseIcon__2i8v6","toggleText":"PatientProfile__toggleText__2P4NG"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/PatientProfile/PatientProfile.css
// module id = 1802
// module chunks = 0